import * as React from 'react';

const AlignBottom = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.4 1H4.6V15.4H9.4V1ZM15.4 5.8H10.6V15.4H15.4V5.8ZM19 17.8H1V19H19V17.8Z" fill="currentColor"/>
  </svg>
);

export default AlignBottom;
